

// 卡片列表配置 {id:卡片id,img:卡片正面图}
export const CARD_LIST_CONFIG = [
    {
        id: 'card1',
        img: "https://yun.duiba.com.cn/polaris/card1.87910637be63f1e1ab3ee7c087abde6b3d5d25a7.png",
    },
    {
        id: 'card2',
        img: "https://yun.duiba.com.cn/polaris/card2.27825d29aadb43975d9835388b18bc8a5fe54196.png",
    },
    {
        id: 'card3',
        img: `https://yun.duiba.com.cn/polaris/card3.ea9b4d662f4da0beca86dae2dbb6d39946748a6e.png`,
    },
    {
        id: 'card4',
        img: `https://yun.duiba.com.cn/polaris/card4.db7cb37d818375d1c979cbbc25981bc463296488.png`,
    },
    {
        id: 'card5',
        img: `https://yun.duiba.com.cn/polaris/card5.e23a09bcbe6dce46390c8ed2836ff3ca2b3e2366.png`,
    },
    {
        id: 'card6',
        img: `https://yun.duiba.com.cn/polaris/card6.d5ebde49e7c6cf73c0f70b21963febfe6994eb73.png`,
    },
    {
        id: 'card7',
        img: `https://yun.duiba.com.cn/polaris/card7.ece51877e78e6d27dcc4a37f45f999e5650aab62.png`,
    },
    {
        id: 'card8',
        img: `https://yun.duiba.com.cn/polaris/card8.3916741c0767a0053e87e590e6ea85fcf0975984.png`,
    },
]

/**
 * 描述 根据卡片id 寻找索引
 * @date 2022-12-05
 * @param {any} cardId
 * @returns {any}
 */
export const getIndexById = (cardId) => {
    return CARD_LIST_CONFIG.findIndex((val) => val.id === cardId);
}

export const getImgById = (cardId) => {
    const target = CARD_LIST_CONFIG.find(val => val.id === cardId);
    if (target !== null) {
        console.log(target.img)
        return target && target.img
    } else {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/page/Homepage/constant.js